import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { IstSummaryService } from 'src/app/services/ist/ist-summary.service';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { DatePickerGlobalOptions } from '../../../constants/service.constants';
import { DatePipe } from '@angular/common';
import { EapStudyReportsViewModalComponent } from './eap-study-reports-view-modal/eap-study-reports-view-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-eap-study-reports',
  templateUrl: './eap-study-reports.component.html',
  styleUrls: ['./eap-study-reports.component.scss']
})
export class EapStudyReportsComponent implements OnInit {
  columnDefs;
  operations;
  tempoperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  ApplicationID: string;
  studyreportsform: UntypedFormGroup;
  permission: string = "";
  userType: string = "";
   typeOptions: any[];
  constructor(
    private summaryService: IstSummaryService,
    private datashareService: IstDataShareService,
    private commonService: CommonService,
    private userService: UserService,
    private datepipe: DatePipe

  ) {
  }

  ngOnInit() {

    this.permission = "";
    //if (this.commonService.getPagePermission("FBED3501EA0E470CB84D8C4A5AD39ECD") != null && this.commonService.getPagePermission("FBED3501EA0E470CB84D8C4A5AD39ECD") != undefined) {
    //  this.permission = this.commonService.getPagePermission("FBED3501EA0E470CB84D8C4A5AD39ECD").toLowerCase();
    //}

    if (this.commonService.getPagePermission("EAP07") != null && this.commonService.getPagePermission("EAP07") != undefined) {
      this.permission = this.commonService.getPagePermission("EAP07").toLowerCase();
    }

    this.userType = this.userService.getUserType();
    this.studyreportsform = new UntypedFormGroup({
      Type: new UntypedFormControl(null),
      Title: new UntypedFormControl(null),
      PatientName: new UntypedFormControl(null),
      SubmittedDateFrom: new UntypedFormControl(null),
      SubmittedDateTo: new UntypedFormControl(null),

    });
   
   // if (this.ApplicationID == "" || this.ApplicationID == undefined) {
      this.datashareService.ApplicationID.subscribe(x => {
        this.ApplicationID = x;
      });
   // }
    this.columnDefs = [
      {
        "headerName": "Type",
        "field": "Type",
        "tooltipField": "Type"
      },
      {
        "headerName": "Title",
        "field": "Title",
        "tooltipField": "Title"
      },
      {
        "headerName": "Patient Name (Patient ID)",
        "field": "PatientName",
        "tooltipField": "PatientName"
      },
      {
        "headerName": "Submitted Date",
        "field": "SubmittedDateStr",
        "tooltipField": "Submitted Date"
      }
    ];

    this.tempoperations = [
       
    ];
    if (this.permission == "new" && this.userType=="E") {
      this.tempoperations.push({
        "name": "Add",
        "id": "add"
      });
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
      this.tempoperations.push({
        "name": "Delete",
        "id": "delete"
      });
    }
    if (this.permission == "edit") {
      this.tempoperations.push({
        "name": "Edit",
        "id": "edit"
      });
    }

    this.advanceSearch =
    {
      "fields": [
        {
          "label": "Type",
          "field": "Type",
          "type": "text"
        },
        {
          "label": "Title",
          "field": "Title",
          "type": "text"
        },
        {
          "label": "Patient Name",
          "field": "PatientName",
          "type": "text"
        },
        {
          "label": "Submitted Date (From)",
          "field": "SubmittedDateFrom",
          "type": "date"
        },
        {
          "label": "Submitted Date (End)",
          "field": "SubmittedDateTo",
          "type": "date"
        }
      ]
    };

     this.operations = this.tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    if (this.ApplicationID == "" || this.ApplicationID == undefined || this.ApplicationID == null) {
      this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Please save the first form of the application, before navigating to the other forms." } } });
      return false;
    }
    this.GetSummaryData();
    this.GetDropDownsData1();

  }
 GetDropDownsData1() {
    this.summaryService.masterData("api/EAPStudyreports/GetMasterData?ApplicationID=" + this.ApplicationID + "&RecordID=").subscribe(summary => {
      this.typeOptions = summary["MasterData1"];
     
    });
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }


  onCallbackOperation(opr) {
    opr.callback(this.summaryService);
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  
  onRowDoubleClicked(event) {
   
  }

  add() {
    // let modalRef = this['self'].modalService.show(EapStudyReportsViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-llg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: 'Add',
    //     content: { id: "", ApplicationID: this.ApplicationID }
    //   }
    // });
    // modalRef.content.action.subscribe(result=>{
    //   this['self'].GetSummaryData();
    // })
  }

  edit() {
    // let hedingText = "Edit";
    // if (this['self'].selectedRow["SubmittedDateStr"] != undefined && this['self'].selectedRow["SubmittedDateStr"] != "" && this['self'].selectedRow["SubmittedDateStr"] != null) {
    //   hedingText = "View";
    // }
    // let modalRef = this['self'].modalService.show(EapStudyReportsViewModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   ignoreBackdropClick: true,
    //   class:'modal-llg modal-full-height modal-right',
    //   animated: true,
    //   data: {
    //     heading: hedingText,
    //     content: { id: this['self'].selectedRow['ID'], ApplicationID: this.ApplicationID }
    //   }
    // });
    // modalRef.content.action.subscribe(result=>{
    //   this['self'].GetSummaryData();
    // })
  }
  
  delete(Service, toastrService) {
      ;
    // if (this['self'].userType == "E") {
    //   if (this['self'].selectedRow['SubmittedDateStr'] == null || this['self'].selectedRow['SubmittedDateStr'] == undefined || this['self'].selectedRow['SubmittedDateStr'] == "") {
    //     let id = this['self'].selectedRow['ID'];
    //     this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
    //     this["self"].modalRef.content.action.subscribe(result => {
    //       Service.DeleteRecord('api/EAPStudyreports/Delete?RecordID=' + id).subscribe(summary => {
    //         debugger;
    //         if (summary["Status"] == 0) {
    //           toastrService.success("Selected Record(s) has been Deleted");
    //           this['self'].GetSummaryData();
    //         }
    //         else {
    //           toastrService.error("Referenced record Can't be Deleted.");

    //         }
    //       });
    //     })

    //   }
    //   else {
    //     this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted." } } });
    //   }
    // }
    // else {
    //   this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: "Record Can't be deleted." } } });
    // }
  }

  GetSummaryData() {
    this.SearchClear();
    this.summaryService.getSummaryData("api/EAPStudyreports/getSummaryData?ApplicationID="+this.ApplicationID).subscribe(summary => {
      this.rowData = summary
    });
  }
  getSummarySearch(searchObject) {
    this.summaryService.fetchSearchData("api/EAPStudyreports/getSummarySearchData", searchObject).subscribe(summary => {
      this.rowData = summary
    });
  }
  SearchClear() {
    this.studyreportsform.reset();
      //  this.setSummary();
    }
  AdvanceSearch() {
      var formData = this.studyreportsform.value;
    formData["ApplicationID"] = this.ApplicationID;
    if (formData["SubmittedDateFrom"] != null && formData["SubmittedDateFrom"] != "") {
      formData["StartDateStr"] = this.datepipe.transform(formData["SubmittedDateFrom"], 'dd-MMM-yyyy');
    }
    if (formData["SubmittedDateTo"] != null && formData["SubmittedDateTo"] != "") {
      formData["EndDateStr"] = this.datepipe.transform(formData["SubmittedDateTo"], 'dd-MMM-yyyy');
    }
    formData["SubmittedDateFrom"] = null;
    formData["SubmittedDateTo"] = null;
    this.getSummarySearch(formData);
  }

  onAdvanceSearchOperation(searchFiletrs) {

  }

}
